import DigitalKPIs from 'components/Main/DigitalKPIs';
import { AudienceReport, Graphs, MainContainer, Tables } from 'components/Main/Main.styles';
import { Add, StyledTableContainer, TxtContainer2 } from 'components/Main/table/TableStyles';
import { useCampaignContext } from 'context/CampaignContext';
import ClientStatementsContext from 'context/ClientStatementsContext';
import { fullSources, useDataSources } from 'customHooks/useDataSources';
import { useGetStoredQueriesDetails } from 'customHooks/useGetStoredQueriesDetails';
import { useContext, useEffect, useState } from 'react';
import { useTemplateContext } from 'context/TemplateContext';
import ARContainer from 'components/Main/Gallery/ARContainer';
import { PublishContext } from 'context/PublishContext';
import SortingPlaceHolderList from './SortingPlaceHolderList';
import { StyledGraphContainer } from 'components/Main/graf/GraphStyles';
import ReactLoading from 'react-loading';
import { useTheme } from 'styled-components';
import ClientPlaceholderContainer from './CLIENTCOMPONENTS/ClientPlaceholderContainer';
import InputContext, { creativeLibrarySectionType } from 'context/InputContext';
import NoCampaignSelected from './NoCampaignSelected';
import { StoreQueriesV2MutationVariables } from 'API';
import CreativeLibrarySection from './CreativeLibrarySection';
import AddCreativeLibrarySectionModal from './AddCreativeLibrarySectionModal';
import { prepQuery } from 'methods/prepQuery';
import AuthContext from 'context/AuthContext';
import { useDataQuery } from 'customHooks/useDataQuery';
import { useStoreQueries } from 'customHooks/useStoreQueries';
import { processDataSource } from 'utils/processDataSource';

type Props = {};

export type PlaceholderType = {
  type: 'Chart' | 'Table';
  minor: number;
  id: string;
  query_id?: string;
  duplicated?: boolean;
  original_id?: string;
  original_minor?: string;
  saved?: boolean;
  isChangedFromOriginal?: boolean;
};

const Main = (props: Props) => {
  const { activeCampaign, canDoInsourceAndOnInsourcePortal } = useCampaignContext();
  const { user } = useContext(AuthContext);
  const { statements } = useContext(ClientStatementsContext);
  const [newPlaceholder, setNewPlaceholder] = useState<PlaceholderType | undefined>(undefined);
  const { fetchedPlaceholders } = useTemplateContext();
  const { publishedData } = useContext(PublishContext);
  const theme = useTheme();
  const [dataSources] = useDataSources(activeCampaign);
  const [addingNewTable, setAddingNewTable] = useState(false as boolean);
  // const { userCanDoInsource } = useClientContext()
  const [
    storedQueries,
    setStoredQueries,
    tablePlaceholderList,
    setTablePlaceholderList,
    setGraphPlaceholderList,
    graphPlaceholderList,
    publishedQueries,
    creativeLibraryQueries,
  ] = useGetStoredQueriesDetails(activeCampaign, newPlaceholder, fetchedPlaceholders, publishedData, setAddingNewTable);
  const { order2Table, order2Chart, setCapture } = useContext(InputContext);
  const [newPlaceholderItem, setNewPLaceholderItem] = useState(undefined as PlaceholderType | undefined);

  const componentIDs = [
    ['3.1', '3.2', '3.3', '3.4', '3.5'],
    ['4.1', '4.2', '4.3', '4.4', '4.5'],
    ['5.1', '5.2', '5.3', '5.4', '5.5'],
  ];

  const [uploadComponents, setUploadComponents] = useState<any[]>([]);

  // Creative Library state

  // const [creativeLibrarySections, setCreativeLibrarySections] = useState<CreativeLibrarySection[]>([]);
  const { creativeLibrarySections, setCreativeLibrarySections, convertBackendCreativeToLocal, detectFileTypeFromName } =
    useContext(InputContext);
  const [showAddSectionModal, setShowAddSectionModal] = useState(false);
  useEffect(() => {
    setUploadComponents([
      [
        {
          id: '3.1',
          visible: true,
        },
        {
          id: '3.2',
          visible: storedQueries.some((el) => el?.position === '3.2')
            ? true
            : storedQueries.some((el) => el?.position === '3.1')
              ? true
              : false,
        },
        {
          id: '3.3',
          visible: storedQueries.some((el) => el?.position === '3.3')
            ? true
            : storedQueries.some((el) => el?.position === '3.2')
              ? true
              : false,
        },
        {
          id: '3.4',
          visible: storedQueries.some((el) => el?.position === '3.4')
            ? true
            : storedQueries.some((el) => el?.position === '3.3')
              ? true
              : false,
        },
        {
          id: '3.5',
          visible: storedQueries.some((el) => el?.position === '3.5')
            ? true
            : storedQueries.some((el) => el?.position === '3.4')
              ? true
              : false,
        },
      ],
      [
        {
          id: '4.1',
          visible: storedQueries.some((el) => el?.position === '4.1')
            ? true
            : storedQueries.some((el) => el?.position === '3.5')
              ? true
              : false,
        },
        {
          id: '4.2',
          visible: storedQueries.some((el) => el?.position === '4.2')
            ? true
            : storedQueries.some((el) => el?.position === '4.1')
              ? true
              : false,
        },
        {
          id: '4.3',
          visible: storedQueries.some((el) => el?.position === '4.3')
            ? true
            : storedQueries.some((el) => el?.position === '4.2')
              ? true
              : false,
        },
        {
          id: '4.4',
          visible: storedQueries.some((el) => el?.position === '4.4')
            ? true
            : storedQueries.some((el) => el?.position === '4.3')
              ? true
              : false,
        },
        {
          id: '4.5',
          visible: storedQueries.some((el) => el?.position === '4.5')
            ? true
            : storedQueries.some((el) => el?.position === '4.4')
              ? true
              : false,
        },
      ],
      [
        {
          id: '5.1',
          visible: storedQueries.some((el) => el?.position === '5.1')
            ? true
            : storedQueries.some((el) => el?.position === '4.5')
              ? true
              : false,
        },
        {
          id: '5.2',
          visible: storedQueries.some((el) => el?.position === '5.2')
            ? true
            : storedQueries.some((el) => el?.position === '5.1')
              ? true
              : false,
        },
        {
          id: '5.3',
          visible: storedQueries.some((el) => el?.position === '5.3')
            ? true
            : storedQueries.some((el) => el?.position === '5.2')
              ? true
              : false,
        },
        {
          id: '5.4',
          visible: storedQueries.some((el) => el?.position === '5.4')
            ? true
            : storedQueries.some((el) => el?.position === '5.3')
              ? true
              : false,
        },
        {
          id: '5.5',
          visible: storedQueries.some((el) => el?.position === '5.5')
            ? true
            : storedQueries.some((el) => el?.position === '5.4')
              ? true
              : false,
        },
      ],
    ]);
  }, [storedQueries]);

  useEffect(() => {
    console.log(
      'Creative Library storedQueries: ',
      storedQueries.filter((query) => query?.position?.startsWith('9')),
    );
  }, [storedQueries]);

  useEffect(() => {
    console.log('Creative Library Sections updated: ', creativeLibrarySections);
  }, [creativeLibrarySections]);

  // useEffect to populate Creative Library sections for unauthorized users from published data
  useEffect(() => {
    if (!activeCampaign?.authorized && creativeLibraryQueries.length > 0 && publishedQueries.length > 0) {
      // Convert published Creative Library queries to Creative Library sections for unauthorized users
      const publishedCreativeLibrarySections = creativeLibraryQueries.map((query) => {
        // Find the corresponding published query with outputlocation and creatives data
        const publishedQuery = publishedQueries.find((pq) => pq.position === query.position);

        const section: creativeLibrarySectionType = {
          position: query.position || '',
          dataSourceName: query.query_id || '',
          data: [], // No live data for unauthorized users
          outputLocation: publishedQuery?.outputlocation || '',
          title: query.title || undefined,
          creatives: [], // Will be populated from published creatives below
        };

        // Process creatives from published data if they exist
        if (publishedQuery?.creatives && Array.isArray(publishedQuery.creatives)) {
          section.creatives = publishedQuery.creatives
            .filter((creative): creative is NonNullable<typeof creative> => creative !== null)
            .map((backendCreative) => ({
              id: backendCreative.id || '',
              file: backendCreative.creativeOutputLocation || '', // Use S3 URL as file for unauthorized users
              fileType: detectFileTypeFromName(backendCreative.creativeOutputLocation || ''), // Auto-detect file type from filename
              position: backendCreative.position || 0,
              creativeID: backendCreative.creativeID || '',
              creativeName: backendCreative.creativeName || '',
              metrics: (backendCreative.metrics || [])
                .filter((metric): metric is NonNullable<typeof metric> => metric !== null)
                .map((metric) => ({
                  position: metric.position || 0,
                  label: metric.label || '',
                  value: metric.value || 0,
                  column: metric.column || undefined,
                  decimals: metric.decimals ?? 2,
                })),
            }));
        }

        return section;
      });

      // Set the Creative Library sections for unauthorized users
      setCreativeLibrarySections(publishedCreativeLibrarySections);
    }
  }, [
    activeCampaign?.authorized,
    creativeLibraryQueries,
    publishedQueries,
    setCreativeLibrarySections,
    detectFileTypeFromName,
  ]);

  const clickedAddNewElement = async (
    newElement: string,
    type?: string,
    componentQueryId?: string,
    componentParentId?: string,
  ): Promise<PlaceholderType | undefined> => {
    const isTable = newElement === 'Table';
    const isChart = newElement === 'Chart';

    if (isTable || isChart) {
      const placeholderList = isTable ? tablePlaceholderList : graphPlaceholderList;
      const lastNumber = placeholderList.at(-1);
      const nextNumber = lastNumber
        ? lastNumber.minor + 1
        : storedQueries.filter((el) => el?.position?.startsWith(isTable ? '1' : '2')).length + 10;
      const newPosition = (isTable ? 1 : 2) * 100 + nextNumber;
      const query_id = newPosition;

      const newPlaceholder: PlaceholderType = {
        type: newElement,
        minor: nextNumber,
        id: newPosition.toString(),
        query_id: componentQueryId ?? query_id.toString(),
        duplicated: type === 'duplicated',
        original_id: type === 'duplicated' && componentParentId ? componentParentId : newPosition.toString(),
        saved: false,
      };

      await setNewPlaceholder(newPlaceholder);
      return newPlaceholder;
    }
  };

  const itemCreated = async () => {
    const thisIsNewItem = await clickedAddNewElement('Table');
    setNewPLaceholderItem(thisIsNewItem);
  };

  const findStoredQueryProp = (position: string): any => {
    return storedQueries.find((el) => el?.position === position);
  };

  const findOriginalElement = (query_id: string): PlaceholderType | undefined => {
    const originalElement = tablePlaceholderList.find((el) => el.query_id === query_id);
    if (originalElement) {
      return originalElement;
    } else return undefined;
  };

  const findStoriedQuery = (query_id: string) => {
    return storedQueries.find((el) => el?.query_id === query_id);
  };

  const findPublishedQueryProp = (position: string): any => {
    return publishedQueries.find((el) => el?.position === position);
  };

  const [saveQueries] = useStoreQueries();

  // Hook for loading Creative Library Section data
  const [loadingQueries, setLoadingQueries] = useState<string[]>([]);
  const [userMainQuery, setUserMainQuery] = useState<any>(null);
  const [lastProcessedPosition, setLastProcessedPosition] = useState<string | null>(null);
  const [mainData, , , , mainOL] = useDataQuery({
    query: userMainQuery,
    querySource: 'QUERY',
  });

  useEffect(() => {
    if (mainData && mainOL) {
      // Find which query this data belongs to
      const queryPosition = loadingQueries[0]; // Process first query in queue
      
      // Prevent re-processing the same data
      if (queryPosition === lastProcessedPosition) {
        return;
      }
      
      if (queryPosition) {
        const query = storedQueries.find((q) => q?.position === queryPosition);
        const dataSourceName = query?.query_id;

        // Process creatives from backend if they exist
        const processCreatives = async () => {
          if (query?.creatives && Array.isArray(query.creatives)) {
            const localCreatives = await Promise.all(
              query.creatives
                .filter((creative): creative is NonNullable<typeof creative> => creative !== null)
                .map(async (backendCreative) => {
                  // Convert API Creative type to creativesBackendType for consistency
                  const creativesBackendData = {
                    id: backendCreative.id || '',
                    position: backendCreative.position || 0,
                    creativeOutputLocation: backendCreative.creativeOutputLocation || '',
                    creativeID: backendCreative.creativeID || '',
                    creativeName: backendCreative.creativeName || '',
                    metrics: (backendCreative.metrics || [])
                      .filter((metric): metric is NonNullable<typeof metric> => metric !== null)
                      .map((metric) => {
                        // Auto-update metrics that have column reference
                        let updatedValue = metric.value || 0;
                        const column = metric.column;
                        const decimals = metric.decimals ?? 2;

                        if (column && mainData && Array.isArray(mainData)) {
                          // Find matching data item for this creative
                          const matchingDataItem = mainData.find(
                            (item: any) => item.creative_id === backendCreative.creativeID,
                          );

                          if (matchingDataItem && matchingDataItem[column] !== undefined) {
                            // Update value from current data
                            updatedValue = matchingDataItem[column];
                          }
                        }

                        return {
                          position: metric.position || 0,
                          label: metric.label || '',
                          value: updatedValue,
                          column: column || undefined,
                          decimals: decimals,
                        };
                      }),
                  };
                  return await convertBackendCreativeToLocal(creativesBackendData);
                }),
            );

            return localCreatives;
          }
          return [];
        };

        // Create Creative Library Section with processed creatives
        const createSection = async () => {
          const processedCreatives = await processCreatives();

          // Check if section already exists in local state
          const existingSection = creativeLibrarySections.find((section) => section.position === queryPosition);

          if (existingSection) {
            // Update existing section with creatives and title from backend
            setCreativeLibrarySections(
              creativeLibrarySections.map((section) =>
                section.position === queryPosition
                  ? {
                      ...section,
                      creatives: processedCreatives,
                      ...(query?.title && { title: query.title }), // Update title from backend if it exists
                    }
                  : section,
              ),
            );
          } else {
            // Create new section
            const newSection: creativeLibrarySectionType = {
              position: queryPosition,
              dataSourceName: dataSourceName || '',
              data: Array.isArray(mainData) ? mainData : [],
              outputLocation: mainOL,
              creatives: processedCreatives,
              ...(query?.title && { title: query.title }), // Add title from backend if it exists
            };

            setCreativeLibrarySections([...creativeLibrarySections, newSection]);
          }

          setLastProcessedPosition(queryPosition);
          setLoadingQueries((prev) => prev.filter((pos) => pos !== queryPosition));
          setUserMainQuery(null); // Clear query to allow next one to load
        };

        createSection();
      }
    }
  }, [
    mainData,
    mainOL,
    loadingQueries,
    lastProcessedPosition,
    setCreativeLibrarySections,
    storedQueries,
    creativeLibrarySections,
    convertBackendCreativeToLocal,
  ]);

  // Auto-load Creative Library Sections on page load
  useEffect(() => {
    if (dataSources.length > 0 && storedQueries.length > 0) {
      // Find all stored queries that start with position "9" (Creative Library Sections)
      const creativeLibraryQueries = storedQueries.filter((query) => query?.position?.startsWith('9'));

      // Only check for sections to remove if we have stored queries
      // Don't remove sections that were just added but not yet in storedQueries
      if (creativeLibraryQueries.length > 0) {
        const validSectionPositions = creativeLibraryQueries.map((q) => q.position);
        const sectionsToRemove = creativeLibrarySections.filter(
          (section) => !validSectionPositions.includes(section.position),
        );

        // Only remove sections if they've been around for a bit (not just added)
        // We can check if the section has data loaded as an indicator it's established
        const sectionsToActuallyRemove = sectionsToRemove.filter((section) => section.data && section.data.length > 0);

        if (sectionsToActuallyRemove.length > 0) {
          const filteredSections = creativeLibrarySections.filter(
            (section) => !sectionsToActuallyRemove.includes(section),
          );
          setCreativeLibrarySections(filteredSections);
        }
      }

      // ✅ FIX: Process queries ONE AT A TIME to avoid race condition
      // Find the first query that needs loading
      const queryToLoad = creativeLibraryQueries.find((query) => {
        if (!query?.position) return false;
        
        const isAlreadyLoading = loadingQueries.includes(query.position);
        const isAlreadyLoaded = creativeLibrarySections.some((section) => section.position === query.position);
        
        return !isAlreadyLoading && !isAlreadyLoaded;
      });

      // Only load one query at a time
      if (queryToLoad && !userMainQuery) {
        const dataSourceName = queryToLoad.query_id; // query_id contains the dataSourceName
        const foundDataSource = dataSources.find((ds) => ds.name === dataSourceName);

        if (foundDataSource) {
          // Process dataSource and create query
          const processedDataSource = processDataSource(foundDataSource);
          const q = prepQuery(processedDataSource, true, activeCampaign, user);

          // Add to loading queue and set query
          setLoadingQueries((prev) => [...prev, queryToLoad.position!]);
          setUserMainQuery(q);
        }
      }
    }
  }, [
    dataSources,
    storedQueries,
    activeCampaign,
    user,
    loadingQueries,
    creativeLibrarySections,
    setCreativeLibrarySections,
  ]);

  const handleAddCreativeSection = (
    dataSource: fullSources,
    data: any[],
    outputLocation: string,
    title?: string | undefined,
  ) => {
    const nextPosition = 901 + creativeLibrarySections.length;
    const newSection: creativeLibrarySectionType = {
      position: nextPosition.toString(),
      dataSourceName: dataSource.name,
      data: data,
      outputLocation: outputLocation,
      ...(title && { title: title }),
      autoOpenAddModal: true, // Automatski otvori Add Creative modal
      creatives: [],
    };

    const storeQueryVariables: StoreQueriesV2MutationVariables = {
      campaign_id: activeCampaign?.campaignId?.toString() ?? '',
      position: nextPosition.toString(),
      query_id: dataSource.name,
      creatives: [], // Empty array for new section without creatives yet
    };
    setShowAddSectionModal(false);
    saveQueries(storeQueryVariables).then((res) => {
      if (res === '200') {
        // Update local sections

        setCreativeLibrarySections([...creativeLibrarySections, newSection]);

        // Also add to storedQueries to prevent useEffect from removing it
        const newStoredQuery = {
          __typename: 'UserQuery' as const,
          position: nextPosition.toString(),
          query_id: dataSource.name,
          creatives: [],
          campaign_id: activeCampaign?.campaignId?.toString() ?? '',
          userId: user?.username ?? '',
          outputlocation: null,
          queryId: null,
          customHeader: null,
          customFooter: null,
          customTitle: null,
          ...(title && { title: title }), // Add title if provided
        };
        setStoredQueries([...storedQueries, newStoredQuery]);

        // setShowAddSectionModal(false);
      } else {
        alert('Error saving Creative Library Section');
      }
    });
  };
  return (
    <>
      {(activeCampaign?.authorized || (!activeCampaign?.authorized && canDoInsourceAndOnInsourcePortal)) && (
        <button className="PDFbutton" onClick={() => setCapture(true)}>
          Download PPT
        </button>
      )}

      {activeCampaign ? (
        <>
          {activeCampaign.authorized || (!activeCampaign.authorized && canDoInsourceAndOnInsourcePortal) ? (
            <MainContainer>
              {/*     <DigitalKPIs></DigitalKPIs> */}
              {dataSources.length > 0 /* && storedQueries.length > 0  */ ? (
                <>
                  <div>
                    <DigitalKPIs></DigitalKPIs>
                    <Tables>
                      <SortingPlaceHolderList
                        tablePlaceholderList={tablePlaceholderList}
                        setTablePlaceholderList={setTablePlaceholderList}
                        findStoredQueryProp={findStoredQueryProp}
                        dataSources={dataSources}
                        clickedAddNewElement={clickedAddNewElement}
                        isGraph={false}
                        componentIDPrefix={'1'}
                        setStoredQueries={setStoredQueries}
                        storedQueries={storedQueries}
                        findStoriedQuery={findStoriedQuery}
                        findOriginalElement={findOriginalElement}
                        statements={statements}
                        addingNewTable={addingNewTable}
                        setAddingNewTable={setAddingNewTable}
                        newPlaceholderItem={newPlaceholderItem}
                        setNewPLaceholderItem={setNewPLaceholderItem}
                        type="Table"
                      />
                      {activeCampaign && statements?.Queries?.CREATE && (
                        <div className="addMoreButton" onClick={() => itemCreated()}>
                          + Add Table Placeholder
                        </div>
                      )}
                    </Tables>
                    <>
                      <SortingPlaceHolderList
                        tablePlaceholderList={graphPlaceholderList}
                        setTablePlaceholderList={setGraphPlaceholderList}
                        findStoredQueryProp={findStoredQueryProp}
                        dataSources={dataSources}
                        clickedAddNewElement={clickedAddNewElement}
                        isGraph={true}
                        componentIDPrefix={'2'}
                        setStoredQueries={setStoredQueries}
                        storedQueries={storedQueries}
                        findStoriedQuery={findStoriedQuery}
                        findOriginalElement={findOriginalElement}
                        statements={statements}
                        type="Chart"
                      />
                    </>
                  </div>
                  {uploadComponents.map((ids, index) => (
                    <AudienceReport key={index}>
                      {ids.map((id: any) => (
                        <ARContainer
                          key={id.id}
                          componentID={id.id}
                          visible={id.visible}
                          setUploadComponents={setUploadComponents}
                          uploadComponents={uploadComponents}
                        />
                      ))}
                    </AudienceReport>
                  ))}

                  {/* Creative Library Section */}
                  <Tables style={{ width: '100%', marginBottom: '4rem' }}>
                    {creativeLibrarySections.map((section) => (
                      <CreativeLibrarySection
                        key={section.position}
                        dataSourceName={section.dataSourceName}
                        title={section.title}
                        position={section.position}
                        data={section.data}
                        creatives={section.creatives}
                        storedQueries={storedQueries}
                        setStoredQueries={setStoredQueries}
                      />
                    ))}

                    {activeCampaign && statements?.Queries?.CREATE && (
                      <StyledTableContainer
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                          marginBottom: '1rem',
                        }}
                        expand={0}
                      >
                        <button style={{}} type="button" onClick={() => setShowAddSectionModal(true)}>
                          + Add New Creative Library Section
                        </button>
                      </StyledTableContainer>
                    )}

                    {/* Modals */}
                    <AddCreativeLibrarySectionModal
                      isOpen={showAddSectionModal}
                      onClose={() => setShowAddSectionModal(false)}
                      onConfirm={handleAddCreativeSection}
                      dataSources={dataSources}
                    />
                  </Tables>
                </>
              ) : (
                <>
                  <StyledGraphContainer expand={0}>
                    <TxtContainer2 isGraph={false} displayTxt={0}>
                      <Add isGraph={true}>
                        <div style={{ paddingTop: '50%' }} className="text">
                          <ReactLoading className="loaderCentered" type="spinningBubbles" color={theme.publishButton} />
                        </div>
                      </Add>
                    </TxtContainer2>
                  </StyledGraphContainer>
                </>
              )}
            </MainContainer>
          ) : (
            <MainContainer key={publishedQueries[0]?.outputlocation ?? '123'}>
              <DigitalKPIs></DigitalKPIs>
              <Tables>
                {publishedQueries &&
                  tablePlaceholderList
                    .sort((a, b) => {
                      const orderA = order2Table.find((item) => item.QueryId === a.id)?.Order || 0;
                      const orderB = order2Table.find((item) => item.QueryId === b.id)?.Order || 0;
                      return orderA - orderB;
                    })
                    .map(
                      (el) =>
                        publishedQueries.some((query) => query.position === el.id) && (
                          <ClientPlaceholderContainer
                            key={el.id}
                            publishedQueriesDetails={findPublishedQueryProp(el.id)}
                            isGraph={false}
                            componentID={el.id}
                          ></ClientPlaceholderContainer>
                        ),
                    )}
              </Tables>
              <Graphs dashboard={'online'} columnsNumber={2}>
                {publishedQueries &&
                  graphPlaceholderList
                    .sort((a, b) => {
                      const orderA = order2Chart.find((item) => item.QueryId === a.id)?.Order || 0;
                      const orderB = order2Chart.find((item) => item.QueryId === b.id)?.Order || 0;
                      return orderA - orderB;
                    })
                    .map(
                      (el) =>
                        publishedQueries.some((query) => query.position === el.id) && (
                          <ClientPlaceholderContainer
                            key={el.id}
                            publishedQueriesDetails={findPublishedQueryProp(el.id)}
                            isGraph={true}
                            componentID={el.id}
                          />
                        ),
                    )}
              </Graphs>

              {componentIDs.map((ids, index) => (
                <AudienceReport key={index}>
                  {ids.map((id) => (
                    <ARContainer key={id} componentID={id} />
                  ))}
                </AudienceReport>
              ))}

              {/* Creative Library Section for unauthorized users */}
              {creativeLibrarySections.length > 0 && (
                <Tables style={{ width: '100%', marginBottom: '4rem' }}>
                  {creativeLibrarySections.map((section) => (
                    <CreativeLibrarySection
                      key={section.position}
                      dataSourceName={section.dataSourceName}
                      title={section.title}
                      position={section.position}
                      data={section.data}
                      creatives={section.creatives}
                      storedQueries={storedQueries}
                      setStoredQueries={setStoredQueries}
                      readOnly={true} // Read-only mode for unauthorized users
                    />
                  ))}
                </Tables>
              )}
            </MainContainer>
          )}
        </>
      ) : (
        <NoCampaignSelected page={'Digital'}></NoCampaignSelected>
      )}
    </>
  );
};

export default Main;
